(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('bs-{{ section.id }}');
  if (!section) return;

  section.querySelectorAll('.bs__atc[data-variant]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.variant;
      var label = btn.dataset.label || 'Add to cart';
      if (!id) return;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Added!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function () {
          btn.textContent = '+ ' + label;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error – try again';
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var btn = document.getElementById('ft-scroll-top-{{ section.id }}');
  if (!btn) return;
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-custom"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.getElementById('hero-banner-{{ section.id }}');
  if (!section) return;

  const slides = section.querySelectorAll('.hero-banner__slide');
  const images = section.querySelectorAll('.hero-banner__image');
  const dots   = section.querySelectorAll('.hero-banner__dot');
  const prev   = section.querySelector('.hero-banner__arrow--prev');

  if (slides.length <= 1) return;

  let current = 0;
  let timer;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    images[current] && images[current].classList.remove('is-active');
    dots[current]  && dots[current].classList.remove('is-active');
    dots[current]  && dots[current].setAttribute('aria-selected', 'false');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('is-active');
    images[current] && images[current].classList.add('is-active');
    dots[current]  && dots[current].classList.add('is-active');
    dots[current]  && dots[current].setAttribute('aria-selected', 'true');
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(() => goTo(current + 1), 5000);
  }

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => { goTo(i); startTimer(); });
  });

  if (prev) {
    prev.addEventListener('click', () => { goTo(current - 1); startTimer(); });
  }

  startTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
(function () {

  var section = document.getElementById('rp-{{ section.id }}');
  if (!section) return;

  /* ── Add to cart ── */
  function bindAtcButtons(container) {
    container.querySelectorAll('.rp__atc[data-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id    = btn.dataset.variant;
        var label = btn.dataset.label || 'Add to cart';
        if (!id) return;
        btn.textContent = 'Adding…';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: id, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ Added!';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            btn.textContent = '+ ' + label;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          btn.disabled = false;
        });
      });
    });
  }

  /* ── Fetch recommendations from Shopify API ── */
  var wrapper   = document.getElementById('rp-recommendations-{{ section.id }}');
  if (!wrapper) return;

  var productId = wrapper.dataset.productId;
  var sectionId = wrapper.dataset.sectionId;
  var limit     = wrapper.dataset.limit || 4;
  var baseUrl   = wrapper.dataset.url;

  if (!productId || !baseUrl) {
    bindAtcButtons(section);
    return;
  }

  var fetchUrl = baseUrl + '?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit + '&intent=related';

  fetch(fetchUrl)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser  = new DOMParser();
      var doc     = parser.parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('.rp__grid');
      if (newGrid) {
        wrapper.innerHTML = '';
        wrapper.appendChild(newGrid);
        bindAtcButtons(wrapper);
      } else {
        /* API returned no results — keep fallback already rendered */
        bindAtcButtons(wrapper);
      }
    })
    .catch(function () {
      /* Network error — keep fallback */
      bindAtcButtons(wrapper);
    });

  bindAtcButtons(section);

})();

  } catch(e) { console.error(e); }
})();
})();
